import "./AddSiteToTeam.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import AddSiteToTeamComponentController from "./AddSiteToTeamComponentController";

export default class AddSiteToTeamComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = AddSiteToTeamComponentController;
        this.templateUrl = "/App/Components/Team/AddSiteToTeam/AddSiteToTeam.html";
    }
}

module("mmManagePortal").component("mmAddSiteToTeam", new AddSiteToTeamComponent());
